import { Action, createReducer, on } from '@ngrx/store';
import { Notifications, NotificationsDTO, NotificationsFilters } from '../../commons/models/notifications';
import * as NotificationsActions from '../actions/notifications.actions';

export interface NotificationState {
    list: NotificationsDTO[];
    total: number;
    includes: string[];
    currentPage: number;
    perPage: number;
    order: string;
    direction: string;
    filters: NotificationsFilters;
    dialogId: string;
    selectionDialogId: string;
    notification: NotificationsDTO;
    selectedNotifications: Notifications[];
};

const initialState: NotificationState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    notification: null,
    selectedNotifications: []
};

const notificationsReducer = createReducer(
    initialState,
    on(NotificationsActions.loadNotificationsCompleted, (state, {notifications, currentPage, total, perPage, order, direction, filters, includes}) => {
        return { ...state, list: notifications, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(NotificationsActions.notificationDialogOpened, (state, { dialogId }) => ({
        ...state,
        dialogId,
    })),
);

export function reducer(state: NotificationState | undefined, action: Action){
    return notificationsReducer(state, action);
}